import { CentralizedAnimatedLoader } from '@40seas/payments-shared';
import React, { Suspense } from 'react';

const PaymentAsync = React.lazy(() => import('../../../../components/payments-core/src/lib/Payments'));

export function IntentModal() {
    return (
        <Suspense fallback={<CentralizedAnimatedLoader />}>
            <PaymentAsync />
        </Suspense>
    );
}
